/* eslint-disable camelcase */
<template >
  <div v-role="'func'">
    <br>
    <div>
      <div class="formPosition">
        <v-card style="margin:auto;" width="1200">
          <v-container style="background-color:#006699; color:white;"></v-container>
          <v-progress-linear v-if="progresso" indeterminate color="green" height="10"></v-progress-linear>

          <v-toolbar flat color="white">
            <v-btn @click="openDialog()" style="background-color:#006699;color:white;" outlined> <v-icon md color="white darken-2">add</v-icon> DEFINIR NOVO PLANO </v-btn>
            <v-divider class="mx-8" inset vertical></v-divider>
            <v-toolbar-title> Lista de Planos financeiros {{nivelInstituicao === 1}}</v-toolbar-title>
            <v-divider class="mx-8" inset vertical></v-divider>
            
            <!--  search  -->
            <div class="flex-grow-1"></div>
            <v-btn v-if="searchInDb" @click="initialize(searchInDb)" text icon color="green">
              <v-icon>cached</v-icon>
            </v-btn>
            <v-text-field v-model="searchInDb" append-icon="search" label="Pesquisa" single-line hide-details></v-text-field>
            <!-- end  search  -->
          </v-toolbar>

          <template>
            <v-data-table :headers="(nivelEnsino === 1)?headers:headersNivelEnsinoMedio" :search="searchInDb" :items="produtos" :items-per-page="8">
              <template v-slot:item.meses="{item}">
                <span> {{ utilitarios.reverseGroupConcat(item.meses) }}</span>
              </template>
              <template v-slot:item.status="{item}">
                <span :style="(item.status === 1)?'color:green;font-weight:bold;':'color:red;font-weight:bold;'"> {{ (item.status === 1)?'Activo': 'Não activo' }}</span>
              </template>
        
              <template v-slot:item.action="{ item }">
                <v-menu :offset-x="offsetX" :offset-y="offsetY" bottom origin="center center" transition="scale-transition">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn fab dark small color="#006699" v-bind="attrs" v-on="on">
                      <v-icon dark>menu</v-icon>
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-item @click="ShowMudarEstado(item)">
                      <v-icon v-if="item.status ===0" :style="(item.status ===1)?'color:red':'color:green'">sync</v-icon> {{(item.status ===1)?'Inactivar Plano':'Activar Plano'}}
                    </v-list-item>

                    <v-list-item v-if="role === 'ROLE_SPG' || role === 'ROLE_RPS' || role === 'SUPER_USER'" @click="showEliminar(item)">
                      <v-icon color="red">delete</v-icon> Eliminar
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
            </v-data-table>
          </template>

          <!-- ======================== DIALOGO REGISTRAR BOLSEIRO ===================================== -->
          <v-dialog v-model="cardBolseiro" max-width="600px">
            <v-card>
              <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
              </v-overlay>
              <v-card-title style="background-color:#006699;color:white;border:1px solid #fff;">
                <span class="text-h5">Registrar Bolseiro</span>
              </v-card-title>

              <v-form ref="form" v-model="valid" lazy-validation>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="12">
                      <v-combobox :rules="ruleRequired" v-model="tipoBolseiroSelected" :items="tiposDeBolseiros" @change="selecionarTipoBolseiro()" item-value="tiposDeBolseiros" item-text="descricao" return-object label="Tipo de bolseiro: "></v-combobox>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-combobox v-model="valorDesconto" :disabled="valorDesconto"  label="Valor do desconto"></v-combobox>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-combobox :rules="ruleRequired" v-model="ongBolsaSelected" :items="listaOngBolsas" item-value="listaOngBolsas" item-text="nome" return-object label="Organização:" @change="SelecionarOrganizacao()">
                        <template v-slot:item="{ item }">
                          <v-list-item-avatar v-if="item.icone" color="indigo" class="headline font-weight-light white--text">
                            <v-btn icon fab><v-icon style="color:white;">add</v-icon></v-btn>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title v-text="item.nome"></v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </v-combobox>
                    </v-col>
                  </v-row>
                  <small>*Preencha corretamente os campos</small>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="black darken-1" text @click="fecharCardBolseiro()"> fechar </v-btn>
                  <v-btn color="green darken-1" text :disabled="!valid" @click="verificarBolseiroCadastrado()"> salvar </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>

          <!-- ======================== SECTION -> NOVA ORGANIZAÇÃO ============================================= -->
          <template>
            <v-row justify="center">
              <v-dialog v-model="cardNovaOrganizacao" persistent max-width="500px">
                <v-card>
                  <v-overlay :value="overlayOrganizacao">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                  </v-overlay>
                  <v-card-title>
                    <span class="headline">Nova Organização</span>
                  </v-card-title>
                  <v-form ref="form" v-model="valid" lazy-validation>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="12" md="12">
                            <v-text-field v-model="nomeNovaOrganizacao" label="Forneça o nome da nova organização"></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-form>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn style="color:white;" color="green darken-1" :disabled="!valid" @click="verificarOrganizacao()">Guardar</v-btn>
                    <v-btn @click="fecharCardNovaOrganizacao()">Cancelar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
          </template>
          <!-- ========================================== FIM NOVA ORGANIZAÇÃO ============================================ -->


          <!-- ======================== DIALOGO NOVO ESTUDANTE ===================================== -->
          <v-dialog v-model="dialog" max-width="800px">
            <v-card>
              <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
              </v-overlay>
              <v-card-title style="background-color:#006699;color:white;border:1px solid #fff;">
                <span class="text-h5">Registrar Novo Estudante</span>
              </v-card-title>

              <v-form ref="form" v-model="valid" lazy-validation>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field :rules="ruleTextRequired" v-model="editedItem.nome" label="Nome"></v-text-field>
                    </v-col>

                    <v-col cols="12" md="3" v-if="isAtlantidaOrMazozo">
                      <v-text-field :rules="ruleNumber" v-model="editedItem.numeroProcesso" label="Nº Processo"></v-text-field>
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-text-field required :rules="ruleBI" v-model="editedItem.bi" :label="descricao" v-mask="mascara"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-switch @change="outroDoc()"></v-switch>
                    </v-col>

                    <v-col cols="12" md="3">
                      <template>
                        <v-menu ref="menubi" :rules="ruleTextRequired" v-model="menubi" :close-on-content-click="false" transition="scale-transition" offset-y full-width min-width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field v-model="editedItem.dataemissaobi" :rules="[v => !!v || 'Campo obrigatorio!']" label="Data de emissâo do BI" prepend-icon="event" readonly v-on="on"></v-text-field>
                          </template>
                          <v-date-picker ref="picker" max="2027-12-31" min="1950-01-01" v-model="datebi" @change="saveDatebi"></v-date-picker>
                        </v-menu>
                      </template>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-text-field :rules="ruleTextRequired" v-if="false" v-model="editedItem.pkPessoa" label="chave primaria auto increemente"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field v-model="editedItem.nomedopai" label="Filho de:"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field v-model="editedItem.nomedamae" label=" e de:"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <template>
                        <v-menu ref="menu" v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y full-width min-width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field v-model="editedItem.datanascimento" :rules="[v => !!v || 'Campo obrigatorio!']" label="Data de nascimento" prepend-icon="event" readonly v-on="on"></v-text-field>
                          </template>
                          <v-date-picker ref="picker" v-model="date" max="2022-12-31" min="1950-01-01" @change="saveDate"></v-date-picker>
                        </v-menu>
                      </template>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-combobox :rules="ruleRequired" v-model="editedItem.provincia" :items="provincias" item-value="idProvicia" item-text="descricao" @change="loadMunicipioComb" @click="loadMunicipioComb" return-object label="Natural de:"></v-combobox>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-combobox :rules="ruleRequired" v-model="editedItem.municipio" :items="municipiosFiltered" item-value="idMunicipio" item-text="descricao" return-object label="Municipio"></v-combobox>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-combobox v-model="editedItem.sexo" :rules="ruleRequired" item-value="idSexo" item-text="descricao" :items="dropdowSexo" chips label="Sexo"></v-combobox>
                    </v-col>
                  </v-row>
                  <v-row>

                    <v-col cols="12" :md="(nivelEnsino === 1) ? '4' : '4'">
                      <v-combobox v-if="true" v-model="editedItem.curso" :rules="ruleRequired" item-value="idCurso" item-text="descricao" @change="loadclasse" :items="cursos" chips label="Curso"></v-combobox>
                    </v-col>

                    <v-col cols="12" :md="(nivelEnsino === 1) ? '4' : '4'">
                      <v-combobox v-model="editedItem.classeSelected" :rules="ruleRequired" item-text="descricao" :items="classesFiltered" @change="loadTurmaComb" chips :label="(nivelEnsino === 1) ? 'Selecione o ano académico' : 'Selecione a classe'" return-object></v-combobox>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-combobox v-model="editedItem.periodo" :rules="ruleRequired" item-value="id" item-text="descricao" :items="periodos" chips label="Período"></v-combobox>
                    </v-col>
                    <!-- <v-col v-if="nivelEnsino !== 1" cols="12" md="5">
                      <v-combobox 
                        v-model="editedItem.turma"
                        :rules="ruleRequired"
                        item-text="descricao"
                        :items="turmasFiltered"
                        chips
                        label="Selecione a turma"
                        return-object
                      ></v-combobox>
                    </v-col> -->
                  </v-row>
                  <small>*Preencha correctamente os campos</small>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="black darken-1" text @click="dialog = false"> fechar </v-btn>
                  <v-btn color="green darken-1" text :disabled="!valid" @click="Guardar()"> Guardar </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>
          <!-- =================================================================================================== -->

          <!-- =================================================================================================== -->
          <v-row justify="center">
            <v-dialog v-model="dialogoConcordar" persistent max-width="490">
              <v-card>
                <v-card-title class="headline">Eliminar plano financeiro?</v-card-title>
                <v-card-text>Deseja continuar com a operação ?</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click="dialogoConcordar = false">Cancelar</v-btn>
                  <v-btn color="green darken-1" text @click="eliminarPlano()">Continuar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
          <!-- **************************************************************************************************** -->


          <!-- =================================================================================================== -->
          <v-row justify="center">
            <v-dialog v-model="dialogoConcordarActivar" persistent max-width="490">
              <v-card>
                <v-card-title class="headline">Activar/Inactivar plano financeiro?</v-card-title>
                <v-card-text>Deseja continuar com a operação ?</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click="dialogoConcordarActivar = false">Cancelar</v-btn>
                  <v-btn color="green darken-1" text @click="actualizarPlano()">Continuar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
          <!-- **************************************************************************************************** -->
        </v-card>
      </div>
    </div>
  </div>
</template>
My CRUD
<script>
import axiosPedagogico from '../../plugins/axiosFinancas'
import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
import utilitarios from '../../plugins/utilitarios'
import Swal from 'sweetalert2'
const ls = require('local-storage')
export default {
  directives: { mask },
  data: () => ({
    cardBolseiro: false,
    utilitarios:utilitarios,
    cardNovaOrganizacao: false,
    overlayOrganizacao: false,
    nomeNovaOrganizacao: '',
    bolseiroSelected: null,
    tiposDeBolseiros: [],
    valorDesconto: '',
    tipoBolseiroSelected: null,
    listaOngBolsas: [],
    ongBolsaSelected: null,
    planoObject: null,
    alert: false,
    iconAlert: '',
    alertType: '',
    colorAlert: '',
    msgAlert: '',
    dialogoConcordarActivar: false,
    allowSpaces: false,
    dropdowSexo: [
      { idSexo: 'M', descricao: 'Masculino' },
      { idSexo: 'F', descricao: 'Femenino' }
    ],
    periodos: [
      { id: 'M', descricao: 'Manhã' },
      { id: 'T', descricao: 'Tarde' },
      { id: 'N', descricao: 'Noite' }
    ],
    datebi: null,
    date: null,
    novo: false,
    progresso: false,
    descricao: 'Nº do Bi',
    valid: true,
    menu: false,
    menubi: false,
    ano_actual: ls.get('anolectivo'),
    habilitaBi: false,
    startDate: null,
    cursos: [],
    isLoading: false,
    turmasAll: [],
    servico: '',
    mascara: '#########-AA-###',
    turmasFiltered: [],
    municipiosAll: [],
    produtos: [],
    cor: '',
    municipiosFiltered: [],
    provincias: [],
    searchInDb: '',
    estudantes: [],
    classes: [],
    classesFiltered: [],
    recibos: [],
    servicos: [],
    dialogGrupo: false,
    dialogTaxa: false,
    dialog: false,
    idd: false, // simula autoinclemet
    y: 'top',
    text: 'mensagem nao setada.',
    //  timeout: 4000,
    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value => (value || '').length <= 70 || 'O máximo número de carácters atigidos',
      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],
    ruleBI: [
      value => !!value || 'campo obrigatório.',
      value => value.length === 16 || 'Minimo de caracteres exigido( 16 ).'
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'O máximo número de carácters atigidos',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ],
    headers: [
      {
        text: 'Descricao',
        align: 'start',
        sortable: false,
        value: 'descricao'
      },
      { text: 'Anolectivo', value: 'anolectivo_' },
      { text: 'Semestre', value: 'semestre' },
      { text: 'Meses', value: 'meses' },
      { text: 'Estado', value: 'status' },
      { text: 'autor', value: 'autor' },
       { text: 'Data registro', value: 'data_created' },
       { text: 'Action', value: 'action' }
    ],
    headersNivelEnsinoMedio: [
      {
        text: 'Descricao',
        align: 'start',
        sortable: false,
        value: 'descricao'
      },
      { text: 'Anolectivo', value: 'anolectivo_' },
      { text: 'Meses', value: 'meses' },
      { text: 'Estado', value: 'status' },
      { text: 'autor', value: 'autor' },
       { text: 'Data registro', value: 'data_created' },
       { text: 'Action', value: 'action' }
    ],
    msg: '',
    editedIndex: -1,
    municSelectedForComb: null,
    proviSelectedForComb: null,
    overlay: false,
    estudanteObjecto: null,
    dialogoConcordar: false,
    editedItem: {
      pk_estudante:0,
      numeroProcesso: '',
      pkPessoa: 0,
      classeSelected: '',
      bi: '',
      idPessoa: '',
      municipio: null,
      idPerfil: null,
      nome: '',
      morada: '',
      telefone: '',
      autor: '',
      datanascimento: '',
      data_: '',
      status_2: '',
      email: '',
      sexo: '',
      periodo: '',
      nomedopai: '',
      nomedamae: '',
      numeroProcesso: null,
      dataemissaobi: null,
      provincia: null,
      instituicao: null,
      instituicaodescricao: '',
      curso: null,
      turma: null,
      numeroProcesso: '',
      matriculaAntiga:''
    },
    defaultItem: {
      pk_estudante:0,
      numeroProcesso: '',
      pkPessoa: 0,
      classeSelected: '',
      bi: '',
      idPessoa: '',
      municipio: null,
      idPerfil: null,
      nome: '',
      periodo: '',
      morada: '',
      telefone: '',
      autor: '',
      datanascimento: '',
      data_: '',
      status_2: '',
      email: '',
      sexo: '',
      nomedopai: '',
      nomedamae: '',
      numeroProcesso: null,
      dataemissaobi: null,
      provincia: null,
      instituicao: null,
      instituicaodescricao: '',
      curso: null,
      turma: null,
      numeroProcesso: '',
      matriculaAntiga:'',
    }
  }),

  computed: {

    nivelInstituicao (){
      return ls.get('nivel')
    },

    loggedUserName() {
      return ls.get('nomeUsuario')
    },
    computeddatanascimento() {
      // eslint-disable-next-line no-undef
      return this.editedItem.datanascimento ? moment(this.editedItem.datanascimento).format('dddd, MMMM Do YYYY') : ''
    },
    computedDateFormattedDatefns() {
      // eslint-disable-next-line no-undef
      return this.date ? format(this.date, 'dddd, MMMM Do YYYY') : ''
    },
    nivelEnsino() {
      return 2
    },
    role() {
      return ls.get('role')
    },
    isAtlantidaOrMazozo() {
      return window.location.host.includes('ispatlantida.com') || window.location.host.includes('192.168.44.10') || window.location.host.includes('ispamazozo.com')
    }
  },

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menubi(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    estudantes() {
      this.isLoading = false
      this.$store.state.isloading = false
    },
    dialog(val) {
      val || this.close()
    }
  },

  created() {
    this.initialize();
     
  },

  methods: {
    async initialize() {
      try {
        this.progresso = true;
        this.produtos = await axios.get('/planoFinanceiroFindAll').then(res => res.data);
      } catch (error) {
        this.text = error;
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 });
      } finally {
        this.progresso = false;
      }
    },

    ShowMudarEstado (item) {
      this.dialogoConcordarActivar = true
      this.planoObject = item
    },

    async actualizarPlano () {

      try {
         let result = await axios.post('actualizarPlanoFinanceiro',{plano:this.planoObject}).then((res)=>res.data)
         if(result.affectedRows >= 1){
           Swal.fire('Informação','Plano actualizado com sucesso','success')
           this.dialogoConcordarActivar = false
           setTimeout(() => {
             ls.clear()
            ls.remove('token')
            this.$router.push('/')
           }, 3000);
         }else{
           Swal.fire('Informação','Ocorreu um erro ao tentar efectuar a operação','error')
         }
      } catch (error) {
         Swal.fire('Informação','Ocorreu um erro ao tentar efectuar a operação','error')
      }
        
     

    },

    showEliminar(item){
      this.dialogoConcordar = true
      this.planoObject = item
    },  


    async eliminarPlano () {
       try {
         let result = await axios.post('eliminarPlanoFinanceiro',{plano:this.planoObject}).then((res)=>res.data)
         if(result.affectedRows >= 1){
            Swal.fire('Informação','Plano eliminado com sucesso','success')
            this.initialize()
         }else
          Swal.fire('Informação','Ocorreu um erro ao tentar efectuar a operação','error')
       } catch (error) {
         Swal.fire('Informação','Ocorreu um erro ao tentar efectuar a operação','error')
       }
    },

    async initializeProvincias() {
      try {
        this.progresso = true;
        this.provincias = await axios.get('/provinciaFindAll').then(res => res.data);
      } catch (error) {
        this.text = error;
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 });
      } finally {
        this.progresso = false;
      }
    },

    async initializeCursos() {
      try {
        this.isLoading = true;
        this.cursos = await axiosPedagogico.get('/cursoInstituicaoFindAllIntegracao').then(res => res.data);
      } catch (error) {
        this.text = error;
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 });
      } finally { 
        this.isLoading = false;
      }
    },

    outroDoc() {
      if (this.descricao === 'Outro Doc.') {
        this.editedItem.bi = '';
        this.descricao = 'Nº do Bi';
        this.mascara = '#########-AA-###';
        this.ruleBI = [ value => value.length === 16 || 'Minimo de caracteres exigido( 16 )'];
      } else {
        this.editedItem.bi = '';
        this.descricao = 'Outro Doc.';
        this.mascara = 'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXX';
        this.ruleBI = [ value => value.length >= 6 && value.length <= 30 || 'Minimo de caracteres exigido( 16 )'];
      }
    },

    async mudarNovoEstudante(item) {
      this.estudanteObjecto = item;
      this.dialogoConcordar = true;
    },
    
    showEditarDados(item) {
      this.editedItem = Object.assign(this.editedItem, item);
      this.editedItem.bi = item.nif;
      this.editedItem.numeroProcesso = item.numero_matricula;
      this.editedItem.matriculaAntiga = item.numero_matricula;
      this.editedItem.nomedamae = item.nomemae;
      this.editedItem.nomedopai = item.nomepai;
      let cursoObjecto = this.cursos.filter(c => c.idCurso === item.curso_id)[0]
      let provinciaObject = this.provincias.filter(p => p.descricao === item.provincia)[0]
      let municipioObject = this.municipiosAll.filter(m => m.descricao === item.municipio)[0]
      let sexoObject = this.dropdowSexo.filter(s => s.id === item.sexo)[0]
      this.editedItem.sexo = sexoObject;
      this.editedItem.provincia = provinciaObject;
      this.editedItem.municipio = municipioObject;
      this.editedItem.curso = cursoObjecto;
      this.loadclasseEditar((cursoObjecto === null || cursoObjecto === undefined) ? 5 : cursoObjecto.numero_anos_academicos, item.anoacademico);
      this.dialog = true;
    },

    async MudarTipoEstudante() {
      try {
        this.progresso = true;
        let resultado = await axios.post('/mudarTipoEstudante', { estudante: this.estudanteObjecto, tipo: 1 }).then(res => res.data);
        if (resultado.affectedRows >= 1) {
          this.dialogoConcordar = false;
          Swal.fire('Informação', '<p>Actualização efectuada com sucesso.</p>', 'success');
          this.initialize();
        }
      } catch (error) {
        this.text = error;
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 });
      } finally {
        this.progresso = false;
      }
    },

    async initializeClasses() {
      try {
        this.isLoading = true;
        this.classes = await axios.get('/classeFindAll2').then(res => res.data);
      } catch (error) {
        this.text = error;
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 });
      } finally {
        this.isLoading = false;
      }
    },

    async initializeTurmas() {
      try {
        this.isLoading = true;
        this.turmasAll = await axios.get('/turmasFindAlls').then(res => res.data);
      } catch (error) {
        this.text = error;
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 });
      } finally {
        this.isLoading = false;
      }
    },

    async initializeMunicipios() {
      try {
        this.progresso = true;
        this.municipiosAll = await axios.get('/municipioFindAll').then(res => res.data);
      } catch (error) {
        this.text = error;
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 });
      } finally {
        this.progresso = false;
      }
    },

    // METHODO FOR VALIDATION
    validate() {
      if (this.$refs.form.validate()) {
      } else {
        console.log('elso foraaa')
      }
    },
    reset() {
      this.$refs.form.reset()
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
    close() {
      this.dialog = false
      this.$refs.form.resetValidation()
    },
    saveDate(date) {
      this.$refs.menu.save(date)
      this.editedItem.datanascimento = date
      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.date = new Date(date).toISOString().substr(0, 10)
    },
    saveDatebi(datebi) {
      this.$refs.menubi.save(datebi)
      this.editedItem.dataemissaobi = datebi
      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.datebi = new Date(datebi).toISOString().substr(0, 10)
    },

    async Save() {
      if (this.$refs.form.validate()) {
        this.overlay = true
        let params = {
          pk_estudante: this.editedItem.pk_estudante,
          nome: this.editedItem.nome,
          nif: this.editedItem.nif,
          morada: this.editedItem.morada,
          telefone1: this.editedItem.telefone,
          telefone2: this.editedItem.telefone2,
          email: this.editedItem.email,
          observacao: this.editedItem.observacao,
          produtosDesconto: null,
          descontoPorProduto: null,
          OpcaodescontoGlobal: null,
          descontoGlobal: null
        }

        try {
          //   let  payload =""
          let msg = await axios.post('/clienteInsertOrUpdate', params).then(res => res.data)
          if (msg) {
            this.initialize()
            this.showAlert()
            //this.Limpar()
          }
        } catch (error) {
          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        } finally {
          this.overlay = false;
        }
      }
    },

    showAlert() {
      this.alert = true
      this.tab = 0
      this.colorAlert = 'color:green;'
      this.iconAlert = 'done'
      this.alertType = 'success'
      this.msgAlert = 'Actualização efectuada com sucesso!'
      setTimeout(() => {
        this.alert = false
      }, 4000)
    },

    Limpar() {
      this.editedItem.nome = '';
      this.editedItem.datanascimento = '';
      this.editedItem.nomedopai = '';
      this.editedItem.nomedamae = '';
      this.editedItem.dataemissaobi = '';
      this.editedItem.telefone = '';
    },

    openDialog() {
      this.$router.push('definir-plano-financeiro')
    },

    loadTurmaComb() {
      this.turmasFiltered = []
      this.editedItem.turma = null
      this.turmasFiltered = this.turmasAll.filter(t => t.curso_id === this.editedItem.curso.idCurso && t.classe_id === this.editedItem.classeSelected.pkAnoacademico)
    },

    loadMunicipioComb(provincia) {
      this.municipiosFiltered = this.municipiosAll.filter(municipio => municipio.idProvincia === provincia.idProvincia);
    },

    loadclasse() {
      /**
       * Nivel Ensino
       * 1 - Superioor
       * 2 - Médio
       */
      if (this.nivelEnsino === 1) {
        for (let index = 1; index <= parseInt(this.editedItem.curso.numero_anos_academicos); index++) {
          this.classesFiltered.push({ id: index, descricao: index + 'º ano' })
        }
        this.classesFiltered.push({ id: 100, descricao: 'Monografia' })
      } else {
        let classe = 10
        for (let index = 1; index <= 4; index++) {
          this.classesFiltered.push({ id: index, descricao: classe + 'ª Classe' })
          classe++;
        }
      }
    },

    loadclasseEditar(numeroAnoAcademicos, anoacademicoEstudante) {
      /**
      * Nivel Ensino
      * 1 - Superioor
      * 2 - Médio
      */
      if (this.nivelEnsino === 1) {
        for (let index = 1; index <= parseInt(numeroAnoAcademicos); index++) {
          this.classesFiltered.push({ id: index, descricao: index + 'º ano' })
        }
        this.classesFiltered.push({ id: 100, descricao: 'Monografia' })
        this.editedItem.classeSelected = this.classesFiltered.filter(c => c.id === anoacademicoEstudante)[0]
      } else {
        let classe = 10
        for (let index = 1; index <= 4; index++) {
          this.classesFiltered.push({ id: index, descricao: classe + 'ª Classe' })
          classe++;
        }
      }
    },

    async Guardar() {
      if (this.$refs.form.validate()) {
        try {
          this.overlay = true;
          let params = {
            estudante: this.editedItem,
            nome: (this.editedItem.nome.length <= 0 || this.editedItem.nome === null) ? this.editedItem.nome : utilitarios.SetNameCapitalize(this.editedItem.nome.trim()),
            nomedopai: (this.editedItem.nomedopai.length <= 0 || this.editedItem.nomedopai === null) ? this.editedItem.nomedopai : utilitarios.SetNameCapitalize(this.editedItem.nomedopai.trim()),
            nomedamae: (this.editedItem.nomedamae.length <= 0 || this.editedItem.nomedamae === null) ? this.editedItem.nomedamae : utilitarios.SetNameCapitalize(this.editedItem.nomedamae.trim()),
            autor: ls.get('nomeUsuario'),
            tipoEstudante: 0, // Estudante antigo, apeans não paga matricula
          }
          let result = await axios.post('estudanteInsertOrUpdate', params)
          if (result.data.affectedRows >= 1) {
            utilitarios.showAlertMessage('success', 'Estudante actualizado ou registrado com sucesso.')
            this.dialog = false;
            this.editedItem = this.defaultItem;
            this.initialize();
          } else if (result.data.status === 1122) { // For duplicate entry
            Swal.fire('Informação', '<p>Número do Bilhete ou Processo já registrado.</p>', 'warning')
          } else {
            utilitarios.showAlertMessage('error', 'Ocorreu um erro ao tentar efectuar a operação')
          }
        } catch (error) {
          utilitarios.showAlertMessage('error', 'Ocorreu um erro ao tentar efectuar a operação')
        } finally { 
          this.overlay = false; 
        }
      }
    },

    /**
     * Método responsavél por carregar os dados que serão necessário para registrar um bolseiro.
     * Trás a lista das organizações provedoras de bolsa disponivel
     * Trás a lista de todos os tipos de bolseiros salvo no Banco de dados
     * Caso houver um erro durante a requisição, será exibida uma notificação.
    */
    async carregarDadosBolseiros() {
      try {
        this.progresso = true;
        this.listaOngBolsas = await axios.get('/listarOrganizacoesBolsas').then((res) => res.data);
        this.listaOngBolsas.unshift({ nome: 'Nova Organização', id: -1, icone: true });
        this.tiposDeBolseiros = await axios.get('/listarTiposBolseiros').then((res) => res.data);
      } catch (error) {
        console.log(error);
        utilitarios.showAlertMessage('error', 'Ocorreu um error durante o carregamento da página!')
      } finally {
        this.progresso = false;
      }
    },

    /**
     * Método responsavél tornar o cardBolseiro visivél.
     * Armazena os dados do estudante selecionado na variavél bolseiroSelected
    */
    async registrarBolseiro(estudante) {
      this.cardBolseiro = true;
      this.bolseiroSelected = estudante;
    },

     /**
     * Método responsavél tornar o cardBolseiro invisivél.
     * Reseta o valor das variaveis tipoBolseiroSelected, valorDesconto, ongBolsaSelected
    */
    fecharCardBolseiro() {
      this.tipoBolseiroSelected = null;
      this.valorDesconto = '';
      this.ongBolsaSelected = null;
      this.cardBolseiro = false;
    },

    /**
     * Método responsavél por armazenar o valor(percentagem) na variavél para a exibição na tela
    */
    selecionarTipoBolseiro() {
      this.valorDesconto = this.tipoBolseiroSelected.desconto;
    },

    /**
     * Método responsavél tornar o cardNovaOrganizacao visivél.
     * Verifica se o usuário clicou na opcção "Nova Organização"
     * Reseta o valor da variavel ongBolsaSelected
     * Fecha o cardBolseiro
    */
    SelecionarOrganizacao() {
      if (this.ongBolsaSelected.id === -1) {
        this.cardNovaOrganizacao = true;
        this.ongBolsaSelected = null;
        this.fecharCardBolseiro();
      }
    },

    /**
     * Método responsavel por verificar se a organização já foi cadastrada.
     * Verica se o nome quee está a ser inserido já existe no banco de dados
     * Valida se o campo está vázio
     * Se a organização já for cadastrada antes, será exibido uma notificação
     * Se ainda não foi cadstrada, será chamado o método responsavél por cadastrar
    */
    async verificarOrganizacao() {
      if (this.$refs.form.validate() && this.nomeNovaOrganizacao) {
        let params = {
          nome: this.nomeNovaOrganizacao.trim()
        }
        let organizacaoExistente = await axios.post('/verificarOrganizacaoExistente', params).then((res) => res.data);
        if (organizacaoExistente.length) {
          utilitarios.showAlertMessage('error', 'Organização já registrada!')
        } else {
          this.saveNovaOrganizacao();
        }
      }
    },

    /**
     * Método responsavél por cadastrar a nova organização inserida.
     * Se o cadastro ocrrer com sucesso, fecha o cardNovaOrganizacao e chamará a função this.carregarDadosBolseiros();
     * Caso ocorra um erro durante o cadastramento, será exibido uma notificação
    */
    async saveNovaOrganizacao() {
      if (this.$refs.form.validate()) {
        let params = {
          nomeOrgazacao: this.nomeNovaOrganizacao.trim()
        }

        try {
          this.overlayOrganizacao = true;
          let result = await axios.post('/cadastrarNovaOrganizacao', params).then((res) => res.data);
          if(result.affectedRows >= 0) {
            utilitarios.showAlertMessage('success', 'Organização adicionada com sucesso!');
            this.fecharCardNovaOrganizacao();
            this.carregarDadosBolseiros();
          }
        } catch (error) {
          utilitarios.showAlertMessage('error', 'Ocorreu um erro ao adicionar a nova organização!')
        } finally {
          this.overlayOrganizacao = false;
        }
      }
    },

    /**
     * Método responsavél por fechar o cardNovaOrganizacao.
     * reseta o valor da variavél nomeNovaOrganizacao
    */
    fecharCardNovaOrganizacao() {
      this.nomeNovaOrganizacao = '';
      this.cardNovaOrganizacao = false;
    },

    /**
     * Método responsavel por verificar se o bolseiro já foi cadastrado.
     * Verifica se o bilhete (nif) já existe na tabela bolseiros
     * Se o bolseiro já foi cadastrado antes, será exibido uma notificação
     * Se ainda não foi cadstrado, será chamado o método responsavél por cadastrar
    */
    async verificarBolseiroCadastrado() {
      if (this.$refs.form.validate()) {
        let params = {
          nif: this.bolseiroSelected.nif
        }
        let bolseiroExistente = await axios.post('/vericarBolseiroExistente', params).then((res) => res.data);
        if (bolseiroExistente.length) {
          utilitarios.showAlertMessage('error', 'Bolseiro já registrado!')
        } else {
          this.salvarBolseiro();
        }
      }
    },

    /**
     * Método responsavél por cadastrar umnovo bolseiro.
     * Se o cadastro correr com sucesso, fecha o fecharCardBolseiro e chamará a função this.initialize();
     * Caso ocorra um erro durante o cadastramento, será exibido uma notificação
    */
    async salvarBolseiro() {
      if (this.$refs.form.validate()) {
        let params = {
          nome: this.bolseiroSelected.nome,
          anoLectivo: this.bolseiroSelected.anolectivo,
          curso: this.bolseiroSelected.curso,
          nif: this.bolseiroSelected.nif,
          matricula: this.bolseiroSelected.numero_matricula,
          ongBolsa: this.ongBolsaSelected.nome,
          tipoBolsa: this.tipoBolseiroSelected.tipoBolsa,
          desconto: this.tipoBolseiroSelected.desconto
        }
  
        try {
          this.overlay = true;
          let result = await axios.post('/registrarBolseiro', params).then((res) => res.data);
          if(result.affectedRows >= 0) {
            utilitarios.showAlertMessage('success', 'Bolseiro registrado com sucesso.')
            this.fecharCardBolseiro();
            this.initialize();
          }
        } catch (error) {
          utilitarios.showAlertMessage('error', 'Ocorreu um erro durante o registro do bolseiro!');
        } finally {
          this.overlay = false;
        }
      }
    }
  }
}
</script>
<style scoped></style>
